/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_License_Plate_Must_Be_DifferentInputs */

const en_case_validation_license_plate_must_be_different = /** @type {(inputs: Case_Validation_License_Plate_Must_Be_DifferentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle license plates must be different.`)
};

const pt_br2_case_validation_license_plate_must_be_different = /** @type {(inputs: Case_Validation_License_Plate_Must_Be_DifferentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As placas dos veículos devem ser diferentes.`)
};

/**
* | output |
* | --- |
* | "Vehicle license plates must be different." |
*
* @param {Case_Validation_License_Plate_Must_Be_DifferentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_license_plate_must_be_different = /** @type {((inputs?: Case_Validation_License_Plate_Must_Be_DifferentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_License_Plate_Must_Be_DifferentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_license_plate_must_be_different(inputs)
	return pt_br2_case_validation_license_plate_must_be_different(inputs)
});